import * as firebase from 'firebase'
import {tidyObj} from "../helpers.js"
import Vue from "vue"
export default {
  state: {
      evidences:[],
      scannedItems:{},
			collectedItems:{},
			photos:[],
			artefacts:{},
  },
     
  mutations: {
    setPhotos(state,payload){
      state.photos=payload
    },
    setScannedItems(state,payload){
      state.scannedItems=payload
    },
    setCollectedItems(state,payload){
      state.CollectedItems=payload
    },
    setArtefact(state,payload){
      state.artefacts[payload.modelName]=payload
      console.log(state.artefacts)
    },
    setEvidence(state,payload){
     
      var found=false;
      for(var i in state.evidences ){
        if(state.evidences[i].id==payload.id){
          found=true
          Vue.set(state.evidences,i,payload.content)
          //state.evidences[i]=payload.content
        } 
      }
      if(!found){
        state.evidences.push(payload.content)
      }
     
    }
  },
  actions: {
    
    loadEvidence({ commit,getters },payload){
      console.log("loadEvidence",payload)
      if(getters.getEvidence(payload)){
        console.log("loadEvidence already have",payload)
        return
      }
      commit('loadingText',true)
      let data
      var db = firebase.firestore();
      var docRef = db.collection("Evidence").doc(payload)
      docRef.get().then(function(doc) {
        data=doc.data()
        data.id=payload
          commit('loadingText',false)
          commit('setEvidence',{id:payload,content:tidyObj(data)}) 
      }).catch(function(error) {
          console.log("Error getting document:", error);
          commit('loadingText',false)
        });
    },
    loadArtefact({ commit,getters },payload){
      console.log("LOAD ARTEFACT",payload)
      if(getters.getArtefact(payload)){
        return
      }
      commit('loadingText',true)
      let data
      var db = firebase.firestore();
      var docRef = db.collection("Artefacts").doc(payload)
      docRef.get().then(function(doc) {
        data=doc.data()
          commit('loadingText',false)
          commit('setArtefact',tidyObj(data)) 
      }).catch(function(error) {
          console.log("Error getting artefact: "+payload, error);
          commit('loadingText',false)
        });
    }
  },
  getters: {
    getArtefact: state => id => {
          if(state.artefacts[id]){
              return state.artefacts[id]
          }
      return null
  },
    getArtefacts(state){
      
      return state.artefacts
    },
    getPhotos(state,getters){
      if(getters.getActiveWreckStatus){
        return getters.getActiveWreckStatus.photos
      }
      return state.photos
    },
    getScannedItems(state,getters){
      if(getters.getActiveWreckStatus){
        return getters.getActiveWreckStatus.scannedItems
      }
      return state.scannedItems
    },
    getCollectedItems(state,getters){
      if(getters.getActiveWreckStatus){
        return getters.getActiveWreckStatus.collectedItems
      }
      return state.collectedItems
    },
    getEvidence: state => id => {
        for(var evidence in state.evidences){
            if(state.evidences[evidence].id==id){
                return state.evidences[evidence]
            }
        }
        return null
    },
    
    getEvidences(state){
      return state.evidences
    }
  }
}

